module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "note"
    }
  }, [_c('span', [_c('b', [_c('i', [_vm._v("Author’s Note")])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind"
  }, [_c('span', [_vm._v("It may be interesting to note that U-boats were referred to by both captains and crews as “Iron Coffins.” Rightly so; 736 German submarine crews still lie with their boats on the ocean floor.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("R.R.M.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673c5284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-note.vue
// module id = 72
// module chunks = 0